import { MNHotInstance } from '../../../tableHotInstanceTypes';

/**
 * Returns the current rendered width of every visual column in pixels.
 */
export const getHotTableColumnWidthsPx = (hotInstance: MNHotInstance): number[] => {
    const colWidthsPx: number[] = [];

    for (let col = 0; col < hotInstance.countCols(); col++) {
        colWidthsPx.push(hotInstance.getColWidth(col));
    }

    return colWidthsPx;
};
